import React, { createContext, useContext, useState, useMemo, ReactNode } from 'react';

interface AirlineContextType {
  airline: string;
  setAirline: (airline: string) => void;
}

const AirlineContext = createContext<AirlineContextType | undefined>(undefined);

export const AirlineProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [airline, setAirline] = useState<string>('AS');

  const value = useMemo(() => ({ airline, setAirline }), [airline]);

  return (
    <AirlineContext.Provider value={value}>
      {children}
    </AirlineContext.Provider>
  );
};

export const useAirline = () => {
  const context = useContext(AirlineContext);
  if (!context) {
    throw new Error('useAirline must be used within AirlineProvider');
  }
  return context;
};
